export const SUPPORTS_ARRAY_PROTOTYPE_FIND = "find" in Array.prototype;
